import { render, staticRenderFns } from "./OtherParticipantCard.vue?vue&type=template&id=c381421e&scoped=true"
import script from "./OtherParticipantCard.vue?vue&type=script&lang=js"
export * from "./OtherParticipantCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c381421e",
  null
  
)

export default component.exports